import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto p-4 w-50" }
const _hoisted_2 = { class: "card-title mt-0 mb-4" }

import CombineRollbackContent from "@/components/DailyReportEdit/CombineRollback/CombineRollbackContent.vue";
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import RegisterModal from '@/components/DailyReportEdit/CombineRollback/RegisterModal.vue';
import ButtonArea from '@/components/DailyReportEdit/CombineRollback/ButtonArea.vue';
import combineDailyReportsResponse from 'src/types/responses/combineDailyReports';
import CompleteModal from '@/components/DailyReportEdit/Split/CompleteModal.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';
import Api from '@/services/api/ApiServiceFabrick';
import { useRouter } from 'vue-router';
import i18n from '@/lang/i18n';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CombineRollbackForm',
  props: {
    deliveryPlan: {},
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props

const { loginWithRedirect } = useAuth();
const router = useRouter();
const isOpenConfirmModal = ref<boolean>(false);
const isDisplayCompleteModal = ref<boolean>(false);
const hasError = ref<boolean>(false);

function execCombineRollback() {
  Api().combineRollbackDailyReports(props.deliveryPlan.delivery_plan_id).then((data: combineDailyReportsResponse) => {
    if (data.status) {
      return isDisplayCompleteModal.value = true;
    }
    hasError.value = true;
    props.showFlash(i18n.global.t('pages.dailyReports.splitForm.failedMessage'), 'error', true);
  }).catch((error) => {
    errorHandler(error);
  })
}

function errorHandler(error: any) {
  const res = error.response
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      location.reload()
      break
    case 422:
      hasError.value = true;
      props.showFlash(res.data.errors.delivery_plan_id.join(', '), 'error', true);
      break
  }
}

function moveDailyReportList() {
  router.push({ name: "DailyReport" })
}

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_card, { class: "p-4" }, {
        default: _withCtx(() => [
          _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineRollbackForm.title')), 1),
          _createVNode(CombineRollbackContent, {
            deliveryPlan: props.deliveryPlan
          }, null, 8, ["deliveryPlan"]),
          _createVNode(ButtonArea, {
            modelValue: isOpenConfirmModal.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpenConfirmModal).value = $event)),
            isDisabled: hasError.value
          }, null, 8, ["modelValue", "isDisabled"])
        ]),
        _: 1
      })
    ]),
    _createVNode(RegisterModal, {
      modelValue: isOpenConfirmModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isOpenConfirmModal).value = $event)),
      title: _unref(i18n).global.t('pages.dailyReports.combineRollbackForm.registerModal.title'),
      execCombineRollback: execCombineRollback
    }, null, 8, ["modelValue", "title"]),
    _createVNode(CompleteModal, {
      modelValue: isDisplayCompleteModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isDisplayCompleteModal).value = $event)),
      messages: [
      _unref(i18n).global.t('pages.dailyReports.combineRollbackForm.completeModal.messageRow1'),
      _unref(i18n).global.t('pages.dailyReports.combineRollbackForm.completeModal.messageRow2')
    ],
      moveDailyReportDisplay: moveDailyReportList
    }, null, 8, ["modelValue", "messages"])
  ], 64))
}
}

})